import { render } from "./acceptRead.vue?vue&type=template&id=4a856e4a"
import script from "./acceptRead.vue?vue&type=script&lang=js"
export * from "./acceptRead.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__